

module.exports = function ($) {
    return {
        init: init,
    };

    function init() {
        onCardInput();
    }

    function debounce(callback, delay) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => callback.apply(this, args), delay);
        };
    }

    function checkCardType(value) {
        if (value.startsWith('502125') || value.length < 6) {
            $('#checkBalanceSection #pinCode').attr('required', false);
            $('#checkBalanceSection #pinCodeContainer').css('display', 'none');
        } else {
            $('#checkBalanceSection #pinCodeContainer').css('display', 'block');
            $('#checkBalanceSection #pinCode').attr('required', true);
        }
    }

    function onCardInput() {
        // Attach event listener with debounce on Card Number
        $('#checkBalanceSection #cardNumber').on('input', (event) =>
            debounce(checkCardType(event.target.value), 300)
        );
    }
};
